<template>

  <div id="login" class="centered-container">
    <md-content class="md-elevation-3">
      <div class="title">
        <img :src="imgUrl()">
      </div>

      <div class="form">
        <md-field>
          <label>Usuario</label>
          <md-input v-model="username"  autofocus></md-input>
        </md-field>

        <md-field md-has-password>
          <label>Contraseña</label>
          <md-input v-model="password" type="password"></md-input>
        </md-field>
      </div>

      <div class="actions md-layout md-alignment-center">
        <md-button class="md-raised md-primary"   @click="login" data-toggle="modal" data-target="#loading-modal-modal" >Iniciar Sesión</md-button>
      </div>
    </md-content>    
 
    <modal :name="modalName" cclass="transparent">
      <loading-modal :info="modalInfo"></loading-modal>
    </modal>
    
  </div>
</template>

<script>
let Modal = () => import('reusable/Modal')
let LoadingModal = () => import('components/Modals/LoginModal')

import { mapState } from 'vuex';

export default {
  data() {
    return {
      section: 'Localiza Pérdida Integridad',
      username: '',
      password: '',
      modalName: 'loading-modal'
    }
  },
  computed: {
    ...mapState(['user', 'modalInfo']),
    ...mapState({
      duplicateSession: state => state.duplicateSession
    })
  },
  methods: {
    imgUrl() {
     var img = require('imgs/logos/Logo_' + process.env.SITE_TYPE + '.png')
      return img
    },
    login() {
      this.$store.dispatch('login', { username: this.username, password: this.password });
    }
  },
  components: {
    Modal,
    LoadingModal
  },
  created() {
    if(this.user) {
      return this.$router.replace('/dashboard')
    }
  },
  mounted() {
    document.querySelector('body').addEventListener('keydown', (e) => {
      if(e.code === 'Enter') {
        const loginBtn = document.querySelector('#login-btn');
        if(loginBtn) loginBtn.click()
      }
    })
    if(this.duplicateSession) {
      this.$store.commit('SET_DUPLICATE_SESSION', false);
      alert('Hay otra sesión activa, cierra la sesión anterior para poder iniciar una nueva');
    }
  },
  beforeDestroy() {
    document.querySelector('body').removeEventListener('click', () => { console.log('removed') })
  }
}
</script>

<style lang="scss" scoped>
  @import '~varmix';
.centered-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 100vh;
  
  .title {
    text-align: center;
    margin-bottom: 30px;
    img {
       width: 100%;
    }
  }
  .actions {
    .md-button {
      margin: 0;
    }
  }
  .form {
    margin-bottom: 60px;
  }
  .background {

    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 0;

    background-color: var(--loading-background-color);
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center;

  }
  .md-content {
    z-index: 1;
    padding: 40px;
    width: 100%;
    max-width: 400px;
    position: relative;
    border-radius: 15px;
  }

}
#loading-modal-modal {
  background-color: $loading-modal-bg-color;
}
</style>



// WEBPACK FOOTER //
// Login.vue?0356ed0e